import { useStore } from './useStore';

export const useStoreId = ({ varnish = true, online = true } = {}) => {

  const { storeId } = useStore({ varnish, online });

  return storeId;
};
